module.exports = __webpack_public_path__ + "img/HK1.b06df9f0.jpg";